import React, { useEffect } from "react";
import "./global.css";

const GlobalHero = ({ title, paragraphs = [], variant = "about" }) => {
  useEffect(() => {
    const heroClass = `.hero--${variant}`;
    const handleScroll = () => {
      const hero = document.querySelector(heroClass);
      if (!hero) return;
      if (window.scrollY > 100) {
        hero.style.transform = "scale(0.95)";
        hero.style.transition = "0.5s ease";
      } else {
        hero.style.transform = "scale(1)";
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [variant]);

  return (
    <section className={`hero--${variant}`}>
      <div className="container">
        <div
          className="hero-content"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-once="true"
        >
          <h1>
            {title || "Refrigerated Transport Services in Dubai & UAE"}
          </h1>

          {paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}

          <div className="hero-actions-mini">
            <a
              href="https://wa.me/971544792905?text=Hi%20I%20want%20to%20book%20a%20service"
              target="_blank"
              rel="noopener noreferrer"
              className="mini-btn primary"
            >
              Whatsapp Now
            </a>
            <a href="tel:+971544792905" className="mini-btn secondary">
              Call Now
            </a>
          </div>

        </div>
      </div>
    </section>

  );
};

export default GlobalHero;
